import { dropdownTriggerClassname } from "app/components/Dropdown";
import { TagIcon } from "app/components/Icons";
import Pill from "app/components/Pill";
import CustomTooltip from "app/components/Tooltip";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import { getTagsByIds } from "app/containers/Features/components/CommonTagSelection/helper";
import { selectTagList } from "app/redux/selector";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { TicketTagsActionsEnum } from "../types";

interface TagProps {
  tagIds: string[];
  onUpdate: (tags: string[], action: TicketTagsActionsEnum) => void;
}

const TagSelection: React.FC<TagProps> = ({ tagIds, onUpdate }) => {
  const tagList = useSelector(selectTagList);

  const tagsObj = useMemo(() => {
    return getTagsByIds(tagList, tagIds);
  }, [tagList, tagIds]);

  const handleSelectionChange = (ids: string[]) => {
    const isRemoving = ids.every((id) => tagIds.includes(id));
    const action = isRemoving
      ? TicketTagsActionsEnum.REMOVE
      : TicketTagsActionsEnum.ADD;

    onUpdate(ids, action);
  };
  return (
    <div className="relative w-full ">
      <CommonTagSelection
        trigger={
          <button
            className={clsx(
              "flex items-center p-[6px] w-full gap-1 outline-none focus:outline-none ",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Set tags"
              className="flex flex-row items-start gap-1 w-full"
              position="left"
            >
              <TagIcon size={20} />
              <div className="w-full flex flex-row items-center flex-wrap gap-1">
                {tagsObj &&
                  tagsObj?.map((tag) => {
                    return (
                      <Pill
                        key={tag?.title}
                        className="!px-[6px] "
                        backgroundColor={tag?.color}
                        name={tag?.title}
                      />
                    );
                  })}
              </div>
            </CustomTooltip>
          </button>
        }
        selectedTags={tagIds}
        onTagsChange={handleSelectionChange}
        isHeader="Tags"
      />
    </div>
  );
};

export default TagSelection;
